angular.module('impactx.rfxsupplier').controller('RFXSupplierDatesCtrl', [
    RFXSupplierDatesController
]);

function RFXSupplierDatesController() {
    var self = this;

    self.$onInit = function () {
        self.cardExpanded = !self.isClosed;
    };

    self.toggleCardExpansion = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        self.cardExpanded = !self.cardExpanded;
    };
}